// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__5-E6E","disabled":"FileBtn_disabled__HP-cq","warn":"FileBtn_warn__1A1S4","fade":"FileBtn_fade__zWfnq"};